<div *ngIf="asset">
  <transloco
    id="3b07e0fb-d68c-4d3a-9f77-8f20bef30632"
    [key]="
      (accountLinked$ | async)
        ? faqLink
          ? 'commercialCheckout.confirmationVendorInstructions.instructionsWithFaqAndVendorAccount'
          : 'commercialCheckout.confirmationVendorInstructions.instructionsWithVendorAccount'
        : faqLink
        ? 'commercialCheckout.confirmationVendorInstructions.instructionsWithFaq'
        : 'commercialCheckout.confirmationVendorInstructions.instructions'
    "
    [params]="{
      productName: asset.product.productLocalization.productName,
      vendorName: asset.product.productLocalization.vendorName,
      faqLink: { url: faqLink, class: 'text-p-40', target: '_blank', id: '93efe36f-31e4-4668-b281-bb252b31343d' }
    }"></transloco>
</div>
